<template>
  <div class="mod-config">
    <el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList()">
      <el-form-item>
        <el-input v-model="dataForm.key" :placeholder="$t('refund.userAccountOrReason')" clearable></el-input>
      </el-form-item>
      <el-form-item>
        <el-select v-model="dataForm.status" :placeholder="$t('refund.processingStatus')" clearable>
          <el-option :label="$t('refund.pending')" :value="0"></el-option>
          <el-option :label="$t('refund.approved')" :value="1"></el-option>
          <el-option :label="$t('refund.rejected')" :value="2"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button @click="getDataList()">{{ $t('common.search') }}</el-button>
        <el-button type="primary" @click="handleReset()">{{ $t('common.reset') }}</el-button>
      </el-form-item>
    </el-form>
    <el-table
      :data="dataList"
      border
      v-loading="dataListLoading"
      @selection-change="selectionChangeHandle"
      style="width: 100%;">
      <el-table-column
        type="selection"
        header-align="center"
        align="center"
        width="50">
      </el-table-column>
      <el-table-column
        prop="id"
        header-align="center"
        align="center"
        width="80"
        :label="$t('common.id')">
      </el-table-column>
      <el-table-column
        prop="appointmentId"
        header-align="center"
        align="center"
        :label="$t('refund.appointmentId')">
      </el-table-column>
      <el-table-column
        prop="userId"
        header-align="center"
        align="center"
        :label="$t('refund.userAccount')">
      </el-table-column>
      <el-table-column
        prop="refundAmount"
        header-align="center"
        align="center"
        :label="$t('refund.refundAmount')">
        <template slot-scope="scope">
          ¥{{ scope.row.refundAmount }}
        </template>
      </el-table-column>
      <el-table-column
        prop="reason"
        header-align="center"
        align="center"
        show-overflow-tooltip
        :label="$t('refund.reason')">
      </el-table-column>
      <el-table-column
        prop="status"
        header-align="center"
        align="center"
        :label="$t('refund.processingStatus')">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.status === 0" type="warning">{{ $t('refund.pending') }}</el-tag>
          <el-tag v-else-if="scope.row.status === 1" type="success">{{ $t('refund.approved') }}</el-tag>
          <el-tag v-else-if="scope.row.status === 2" type="danger">{{ $t('refund.rejected') }}</el-tag>
          <el-tag v-else type="info">{{ $t('refund.unknownStatus') }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column
        prop="createTime"
        header-align="center"
        align="center"
        width="180"
        :label="$t('refund.applyTime')">
      </el-table-column>
      <el-table-column
        header-align="center"
        align="center"
        width="230"
        :label="$t('common.operation')">
        <template slot-scope="scope">
          <div v-if="scope.row.status === 0">
            <el-button type="success" size="small" @click="handleApprove(scope.row.id)">{{ $t('refund.approve') }}</el-button>
            <el-button type="danger" size="small" @click="handleReject(scope.row.id)">{{ $t('refund.reject') }}</el-button>
          </div>
          <el-button type="text" size="small" @click="viewDetails(scope.row.id)">{{ $t('common.detail') }}</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @size-change="sizeChangeHandle"
      @current-change="currentChangeHandle"
      :current-page="pageIndex"
      :page-sizes="[10, 20, 50, 100]"
      :page-size="pageSize"
      :total="totalPage"
      layout="total, sizes, prev, pager, next, jumper">
    </el-pagination>
    
    <!-- 拒绝退款对话框 -->
    <el-dialog
      :title="$t('refund.rejectRefund')"
      :visible.sync="rejectDialogVisible"
      width="30%">
      <el-form :model="rejectForm" label-width="80px">
        <el-form-item :label="$t('refund.rejectReason')">
          <el-input type="textarea" v-model="rejectForm.response" :rows="4" :placeholder="$t('refund.inputRejectReason')"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="rejectDialogVisible = false">{{ $t('common.cancel') }}</el-button>
        <el-button type="primary" @click="confirmReject">{{ $t('common.confirm') }}</el-button>
      </span>
    </el-dialog>
    
    <!-- 详情对话框 -->
    <el-dialog
      :title="$t('refund.refundDetails')"
      :visible.sync="detailsDialogVisible"
      width="50%">
      <div v-if="refundDetails">
        <el-descriptions border :column="1">
          <el-descriptions-item :label="$t('refund.refundId')">{{ refundDetails.id }}</el-descriptions-item>
          <el-descriptions-item :label="$t('refund.appointmentId')">{{ refundDetails.appointmentId }}</el-descriptions-item>
          <el-descriptions-item :label="$t('refund.userAccount')">{{ refundDetails.userId }}</el-descriptions-item>
          <el-descriptions-item :label="$t('refund.refundAmount')">¥{{ refundDetails.refundAmount }}</el-descriptions-item>
          <el-descriptions-item :label="$t('refund.reason')">{{ refundDetails.reason }}</el-descriptions-item>
          <el-descriptions-item :label="$t('refund.processingStatus')">
            <el-tag v-if="refundDetails.status === 0" type="warning">{{ $t('refund.pending') }}</el-tag>
            <el-tag v-else-if="refundDetails.status === 1" type="success">{{ $t('refund.approved') }}</el-tag>
            <el-tag v-else-if="refundDetails.status === 2" type="danger">{{ $t('refund.rejected') }}</el-tag>
            <el-tag v-else type="info">{{ $t('refund.unknownStatus') }}</el-tag>
          </el-descriptions-item>
          <el-descriptions-item :label="$t('refund.merchantReply')">{{ refundDetails.response || $t('refund.noReply') }}</el-descriptions-item>
          <el-descriptions-item :label="$t('refund.applyTime')">{{ refundDetails.createTime }}</el-descriptions-item>
          <el-descriptions-item :label="$t('refund.processTime')">{{ refundDetails.processTime || $t('refund.notProcessed') }}</el-descriptions-item>
        </el-descriptions>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  export default {
    data () {
      return {
        dataForm: {
          key: '',
          status: null
        },
        dataList: [],
        pageIndex: 1,
        pageSize: 10,
        totalPage: 0,
        dataListLoading: false,
        dataListSelections: [],
        rejectDialogVisible: false,
        rejectForm: {
          refundId: null,
          response: ''
        },
        detailsDialogVisible: false,
        refundDetails: null
      }
    },
    created () {
      this.getDataList()
    },
    methods: {
      // 获取数据列表
      getDataList () {
        this.dataListLoading = true
        this.$http({
        url: '/refund/page', // Directly use the URL
        method: 'get',
        params: {
          'page': this.pageIndex,
          'limit': this.pageSize,
          'key': this.dataForm.key,
          'status': this.dataForm.status
        }
        }).then(({data}) => {
          if (data && data.code === 0) {
            this.dataList = data.data.list
            this.totalPage = data.data.total
          } else {
            this.dataList = []
            this.totalPage = 0
          }
          this.dataListLoading = false
        })
      },
      // 每页数
      sizeChangeHandle (val) {
        this.pageSize = val
        this.pageIndex = 1
        this.getDataList()
      },
      // 当前页
      currentChangeHandle (val) {
        this.pageIndex = val
        this.getDataList()
      },
      // 多选
      selectionChangeHandle (val) {
        this.dataListSelections = val
      },
      // 重置查询条件
      handleReset () {
        this.dataForm.key = ''
        this.dataForm.status = null
        this.getDataList()
      },
      // 批准退款
      handleApprove (id) {
        this.$confirm(this.$t('refund.confirmApprove'), this.$t('common.tip'), {
          confirmButtonText: this.$t('common.confirm'),
          cancelButtonText: this.$t('common.cancel'),
          type: 'success'
        }).then(() => {
          this.$http({
            url: '/refund/process',
            method: 'post',
            params: {
              'refundId': id,
              'approved': true
            }
          }).then(({data}) => {
            if (data && data.code === 0) {
              this.$message({
                message: this.$t('common.operation') + this.$t('common.success'),
                type: 'success',
                duration: 1500,
                onClose: () => {
                  this.getDataList()
                }
              })
            } else {
              this.$message.error(data.msg)
            }
          })
        })
      },
      // 拒绝退款
      handleReject (id) {
        this.rejectForm.refundId = id
        this.rejectForm.response = ''
        this.rejectDialogVisible = true
      },
      // 确认拒绝
      confirmReject () {
        if (!this.rejectForm.response.trim()) {
          this.$message.error(this.$t('refund.pleaseInputRejectReason'))
          return
        }
        
        this.$http({
          url: '/refund/process',
          method: 'post',
          params: {
            'refundId': this.rejectForm.refundId,
            'approved': false,
            'response': this.rejectForm.response
          }
        }).then(({data}) => {
          if (data && data.code === 0) {
            this.$message({
              message: this.$t('common.operation') + this.$t('common.success'),
              type: 'success',
              duration: 1500,
              onClose: () => {
                this.rejectDialogVisible = false
                this.getDataList()
              }
            })
          } else {
            this.$message.error(data.msg)
          }
        })
      },
      // 查看详情
      viewDetails (id) {
        this.$http({
          url: `/refund/info/${id}`,
          method: 'get'
        }).then(({data}) => {
          if (data && data.code === 0) {
            this.refundDetails = data.data
            this.detailsDialogVisible = true
          } else {
            this.$message.error(data.msg || this.$t('refund.getDetailsFailed'))
          }
        })
      }
    }
  }
</script> 